import React, { createContext, useContext, useRef } from 'react';

interface TimelineRefreshContextType {
  refreshTimeline: React.MutableRefObject<(() => void) | null>;
}

const TimelineRefreshContext = createContext<TimelineRefreshContextType | null>(null);

export const useTimelineRefresh = () => {
  const context = useContext(TimelineRefreshContext);
  if (!context) {
    throw new Error('useTimelineRefresh must be used within a TimelineRefreshProvider');
  }
  return context;
};

interface TimelineRefreshProviderProps {
  children: React.ReactNode;
}

export const TimelineRefreshProvider = ({ children }: TimelineRefreshProviderProps) => {
  const refreshRef = useRef<(() => void) | null>(null);

  return (
    <TimelineRefreshContext.Provider value={{ refreshTimeline: refreshRef }}>
      {children}
    </TimelineRefreshContext.Provider>
  );
};
